import React from 'react';

import { flagStyles } from '../settings';

const SvgVU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5712px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVU;
